<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'StrykerApp',
  props: {
    loading: {}
  }
};
</script>

<style lang="scss">
@import '@/sass/stryker/style.scss';
main {
  padding-top: $navbar-height;
  //min-height: 100vh;
  // fixes bug children of parents with min-height can't inherit the height property https://stackoverflow.com/a/21836870
  // height: 1px;
}

#app {
  min-height: 100%;
  background: black !important;

  .version {
    font-size: 1rem;
    position: fixed;
    bottom: 0;
    right: 0;
    opacity: 0.4;
  }
}

.is-guest {
  .logotype {
    position: fixed;
    width: 250px;
    top: 40px;
    left: 50px;
  }
}
</style>
